import Endpoints from "api/endpoints"
import generic from "api/call-deserialize"

export default class PaymentsService {
  static create = (data) =>
    generic({
      apiEndpoint: Endpoints.guests.payments.create,
      apiData: { order: data },
    })

  static capture = (data) =>
    generic({
      apiEndpoint: Endpoints.guests.payments.capture,
      apiData: { razorpay: data },
    })
}
